import type { Assignment } from './api';

export const ANTI_FLICKER_STYLE_ID = '_ab_afs';
export const ANTI_FLICKER_TIMEOUT_MS = 400;

const CSS = `[data-ab-element]{visibility:hidden!important}`;

export function removeAntiFlicker(): void {
  document.getElementById(ANTI_FLICKER_STYLE_ID)?.remove();
}

// Injects a <style> that hides data-ab-element nodes until variants arrive.
// Returns a cleanup function that removes it immediately.
// The style is also removed automatically after ANTI_FLICKER_TIMEOUT_MS so the
// page never stays hidden if the API is slow or fails.
export function installAntiFlicker(): () => void {
  if (document.getElementById(ANTI_FLICKER_STYLE_ID)) {
    return removeAntiFlicker;
  }

  const style = document.createElement('style');
  style.id = ANTI_FLICKER_STYLE_ID;
  style.textContent = CSS;
  document.head.appendChild(style);

  const timer = setTimeout(removeAntiFlicker, ANTI_FLICKER_TIMEOUT_MS);

  return function cleanup() {
    clearTimeout(timer);
    removeAntiFlicker();
  };
}

// Applies variant assignments to DOM elements marked with data-ab-element.
// Swap type is inferred from the tag: <a> → href, <img> → src, else textContent.
// Always removes the anti-flicker guard when done (including on empty list).
export function applySwaps(assignments: Assignment[]): void {
  for (const { elementKey, value } of assignments) {
    const el = document.querySelector<HTMLElement>(`[data-ab-element="${elementKey}"]`);
    if (!el) continue;

    const tag = el.tagName.toLowerCase();
    if (tag === 'a') {
      (el as HTMLAnchorElement).setAttribute('href', value);
    } else if (tag === 'img') {
      (el as HTMLImageElement).setAttribute('src', value);
    } else {
      el.textContent = value;
    }
  }

  removeAntiFlicker();
}
